<template>

  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Merchant Transaction Volume" bc1="App" bc2="Merchant Transaction Volume" :bc3="showMerchantdetails?'Details':'List'"
            path="Merchant Transaction Volume"></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn btn-gradient-danger btn-sm" @click="back">
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card" v-show="!showMerchantdetails">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_status">
              <date-picker :disabledDate="disableFutureDates" v-model="fromDate" valueType="format" class="w-100" :lang="lang" name="fromDate"
                placeholder="choose start date"></date-picker>
            </div>
            <div class="col-md-4 user_status">
              <date-picker :disabledDate="disableFutureDates" v-model="toDate" valueType="format" class="w-100" :lang="lang" name="toDate"
                placeholder="choose end date"></date-picker>
            </div>
            <div class="col-md-4 user_plan">
              <SelectOptions label="" selectAppend="currency" labelValue="code" :filter="{ flag: 'active' }"
                :modelValue.sync="selectedAccount" :url="showSelectAccountOption" />
            </div>


          </div>

          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_status">
              <multiselect v-model="selectedSender" :options="MerchantsData" label="label" track-by="id"
                placeholder="Select Merchant" variant="primary" :custom-label="customNameForMultiselect"></multiselect>
            </div>


            <button type="button" class="btn btn-primary" @click="onSubmitFilters">Search</button>
            <button type="button" class="ml-1 btn btn-danger " @click="clear">Clear</button>
          </div>

        </div>
        <div class="card" v-show="!showMerchantdetails">
          <template>
            <div class="card-body">
              <div class="row">
                <div class="col-12 justify-content-center d-flex">
                  <h3 v-show="showDate">Transaction Volume From <span
                      class="text-warning font-weight-bolder ">{{fromDate?fromDate:'-'}}</span> to <span
                      class="text-warning font-weight-bolder ">{{toDate?toDate:'-'}}</span></h3>
                </div>
              </div>
            </div>
            <CommonTable :url="url" :tableHeaderValues="tableHeaderValues" :actions="actions"
              :deleteActions="deleteActions" :mutedData="mutedData" :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord" :filteredData="filteredData" :show-per-page="true" @getFullResponse="getFullResponse" />
          </template>

        </div>
        <div class="card" v-if="showMerchantdetails">
          <MerchantVolTransctionDetail :filter="filteredDataMerchant" />
        </div>
      </div>

    </div>

  </div>




</template>

<script>

import DatePicker from "vue2-datepicker";
import MerchantVolTransctionDetail from '@/pages/dashboard/stats/MerchantVolTransctionDetail.vue';

export default {
  components: {
    DatePicker,
    MerchantVolTransctionDetail
  },
  created() {
    this.url = "v1/dashboard-overview";
  },
  mounted() {
    localStorage.setItem("url", "v1/dashboard-overview");
    this.checkDataInStore('v1/dashboard-overview')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }


  },
  data() {
    return {
      showMerchantdetails: false,
      selectedSender: null,
      MerchantsData: [],
      loading: false,
      showDate: false,
      currencyCode: '',
      list: [],
      showFilterComp: false,
      url: "v1/dashboard-overview",
      toDate: null,
      fromDate: null,
      selectedAccount: null,
      showSelectAccountOption: '',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      storageKey: "transction-vol",
      filteredData: { transactionsReport: 1 },
      filteredDataMerchant: {},
      tableHeaderValues: [
        {
          title: "Email",
          valueKey: "email",
          html: true,
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return `<a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`;
            }
          }
        },
        {
          title: "Name",
          valueKey: "first_name",
          html: true,
          alter: (value, row) => {
            var html = "-";
            if (value)
              html = `<span class="text-primary" >${row.first_name + ' ' + row.last_name}</span>`;
            return html;
          }
        },
        {
          title: "Business Name",
          valueKey: "business_name",
          html: true,
          alter: function (value) {
            var html = "-";
            if (value)
              html = `<span class="badge badge-light-primary" >${value}</span>`;
            return html;
          }
        },
        {
          title: "Channel",
          valueKey: "channel_name",
          html: true,
          alter: function (value) {
            var html = "-";
            if (value)
              html = `<span class="badge badge-light-secondary" >${value}</span>`;
            return html;
          }
        },
        {
          title: 'Currency',
          valueKey: 'currency_code',
          html: true,
          alter: (value, row) => {
            var html = '-'
            if (value)
              html = ` <div  class="badge badge-light-success">${value}</div>`


            return html
          }
        },
        {
          title: 'Volume',
          valueKey: 'transction_volume',
          html: true,
          alter: (value, row) => {
            var html = '-'

            html = ` <div  class="  text-dark">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</div>`


            return html
          }
        },



      ],
      actions: [
        {
          title: "Details",
          class: "btn-primary btn btn-sm   ml-sm-50",
          cta: (row, index) => {
            this.getMerchantDetails(row)


          }
        },
      ],
      deleteActions: [

      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    back(){
      if(this.showMerchantdetails){
        this.showMerchantdetails = false
      }else{
        this.$router.back()
      }
    },
    getMerchantDetails(row) {
      this.filteredDataMerchant = { 
        ...this.filteredData,
        userId: row.user_id, 
        channelId: row.channel_id, 
        currencyId: row.currency_id, 
        overviewReport: 1, 
        status: 1,
      }

      delete this.filteredDataMerchant['transactionsReport']

     
      
      
      this.showMerchantdetails = true
    },
    customNameForMultiselect({ first_name, last_name, business_name }) {
      return `${first_name} / ${last_name}  ${business_name ? '/' + business_name : ''}`
    },
    getMerchantData() {
      this.makeRequest("post", "v1/get-merchants", { flag: 'all' }, {}, false, true, [205]).then(
        (callResponse) => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            let responseData = callResponse.response.data.data;
            if (code == 200) {
              this.MerchantsData = responseData;

            }
          }
        }
      );
    },
    getFullResponse() {
      this.showSelectAccountOption = 'v1/get-currency'
      if (this.MerchantsData.length == 0)
        this.getMerchantData()
    },

    onSubmitFilters() {
      if ((this.toDate && !this.fromDate) || (!this.toDate && this.fromDate)) {
        this.$toast.error('Both Date Filters Should Be Selected', {
          position: "top-center",
          timeout: 2000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          maxToasts: 1
        })

        return
      }
      if (this.toDate && this.fromDate) {
        this.showDate = true
      }

      let filterData = {}
      if (this.toDate) {
        filterData.toDate = this.toDate
      }
      if (this.fromDate) {
        filterData.fromDate = this.fromDate
      }
      if (this.selectedAccount) {
        filterData.currencyId = this.selectedAccount.id
      }
      if (this.selectedSender) {
        filterData.userId = this.selectedSender.id
      }

      this.filteredData = {
        transactionsReport: 1,
        ...filterData
      }
    },
    clear() {
      this.showDate = false
      this.toDate = null
      this.selectedSender = null
      this.fromDate = null
      this.selectedAccount = null
      this.filteredData = { transactionsReport: 1 }


    },
  }
};
</script>

